export default {
      id: "icon-close-white-usage",
      viewBox: "0 0 8.13 8.13",
      url: __webpack_public_path__ + "Assets/Sprite.svg#icon-close-white",
      toString: function () {
        return this.url;
      }
    }